import React from 'react';

const IconCheckmark = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    viewBox="0 0 14 10"
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M0 0L24 0 24 24 0 24z"
        transform="translate(-5 -7)"
      />
      <path
        {...(color ? {fill: color} : {})}
        fillRule="nonzero"
        d="M10.71 16.29c-.39.39-1.02.39-1.41 0L5.71 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.58 7.59z"
        transform="translate(-5 -7)"
      />
    </g>
  </svg>
);

export default IconCheckmark;
